import {
  createProgressiveFormGroupState,
  createProgressiveNgrxFormReducerWithFormStateUpdate,
  type ProgressiveFormStateImplementor,
} from '@innogy/progressive-ngrx-forms';
import { ChargeCardType } from '@integration/api-client/emobility';
import type { Action } from '@ngrx/store';
import { updateGroup, validate } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';

export interface ChargeCardTypeFormState {
  chargeCardType: ChargeCardType;
}

export interface ChargeCardTypeState
  extends ProgressiveFormStateImplementor<ChargeCardTypeFormState> {}

export const chargeCardTypeFormId = 'emobility-lead-charge-card-type';

const chargeCardInitialState =
  createProgressiveFormGroupState<ChargeCardTypeFormState>(
    chargeCardTypeFormId,
    {
      chargeCardType: ChargeCardType.ChargeCard,
    }
  );

export const initialCardTypeState: ChargeCardTypeState = {
  progressiveForm: chargeCardInitialState,
};

export const validateChargeCardTypeForm = (state: ChargeCardTypeState) => {
  return updateGroup(state.progressiveForm.formState, {
    chargeCardType: validate(required),
  });
};

export const _reducer = createProgressiveNgrxFormReducerWithFormStateUpdate(
  initialCardTypeState,
  validateChargeCardTypeForm
);

export function chargeCardTypeReducer(
  state: ChargeCardTypeState = initialCardTypeState,
  action: Action
): ChargeCardTypeState {
  return _reducer(state, action);
}
